
// Helper functions for odds analysis

/**
 * Filter matches by a specific odds range
 */
export const filterMatchesByOddsRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): any[] => {
  const oddsField = oddsType === 'home' ? 'B365H' : 'B365A';
  
  return matches.filter(match => {
    // Parse odds value, ensuring we handle string or number inputs
    const oddsValue = typeof match[oddsField] === 'string' ? parseFloat(match[oddsField]) : match[oddsField];
    return !isNaN(oddsValue) && oddsValue >= range.min && oddsValue <= range.max;
  });
};
